import lopRequest from '@/api/lopRequest';

export function getPhoneCode(mobile) {
  return lopRequest({
    url: '/lop_project/api/live/login/get_code',
    method: 'post',
    data: {
      mobile,
    },
  });
}

export function phoneLogin(phone, code) {
  return lopRequest({
    url: '/lop_project/api/live/login',
    method: 'post',
    data: {
      code,
      mobile: phone,
    },
  });
}

export function updateUserName(userName) {
  return lopRequest({
    url: '/lop_project/api/live/user/update_username',
    method: 'get',
    params: {
      userName,
    },
  });
}
